// extracted by mini-css-extract-plugin
export var typingIndicator = "_nh-0";